import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import green from '@mui/material/colors/green';
import blue from '@mui/material/colors/blue';
import orange from '@mui/material/colors/orange';
import red from '@mui/material/colors/red';

import Avatar from '@mui/material/Avatar';
import Chip from '@mui/material/Chip';
import Icon from '@mui/material/Icon';

import i18n from 'app/common/i18n';

class ChipComponent extends PureComponent {
  static propTypes = {
    template: PropTypes.oneOf([
      '',
      'success',
      'info',
      'warning',
      'danger',
      'approved',
      'pending_review',
      'draft',
      'deactivated',
      'rejected',
      'active',
      'inactive',
      'waiting',
      'STANDARD',
      'PLUS',
      'PREMIUM'
    ]),
    spacing: PropTypes.bool
  };

  render() {
    const template = TEMPLATES[this.props.template] || {};
    const {
      label,
      chipStyles = {},
      avatarStyles,
      icon,
      template: _, // eslint-disable-line
      spacing,
      selectable,
      i18n,
      disableAvatar,
      ...props
    } = {
      ...template,
      ...this.props
    };

    const style = {
      marginRight: '0.5em',
      ...chipStyles
    };

    if (template.style) {
      Object.assign(style, template.style);
    }

    if (spacing) {
      Object.assign(style, { marginRight: '0.5em', marginBottom: '1em' });
    }

    if (this.props.style) {
      Object.assign(style, this.props.style);
    }

    return (
      <Chip
        {...props}
        sx={{
          '& .MuiChip-label': selectable
            ? {
                userSelect: 'all'
              }
            : undefined
        }}
        style={style}
        avatar={
          disableAvatar ? null : (
            <Avatar style={avatarStyles}>
              <Icon style={{ fontSize: '18px', width: '17px' }}>{icon}</Icon>
            </Avatar>
          )
        }
        label={i18n(label)}
      />
    );
  }
}

export default i18n(ChipComponent);

const TEMPLATES = {
  success: {
    chipStyles: { backgroundColor: green[300] },
    avatarStyles: { backgroundColor: green[900], color: '#fff' },
    icon: 'check'
  },
  verified: {
    chipStyles: { backgroundColor: green[300] },
    avatarStyles: { backgroundColor: green[900], color: '#fff' }
  },
  info: {
    chipStyles: { backgroundColor: blue[200] },
    avatarStyles: { backgroundColor: blue[600], color: '#fff' },
    icon: 'info_outline'
  },
  warning: {
    chipStyles: { backgroundColor: orange[300] },
    avatarStyles: { backgroundColor: orange[900], color: '#fff' },
    icon: 'priority_high'
  },
  danger: {
    // chipStyles: { backgroundColor: orange[300] },
    avatarStyles: { backgroundColor: red[900], color: '#fff' },
    icon: 'clear'
  },
  approved: {
    chipStyles: { backgroundColor: green[300] },
    avatarStyles: { backgroundColor: green[900], color: '#fff' },
    icon: 'spellcheck',
    label: 'Approved'
  },
  pending_review: {
    chipStyles: { backgroundColor: orange[300] },
    avatarStyles: { backgroundColor: orange[900], color: '#fff' },
    icon: 'hourglass_empty',
    label: 'Pending' // 'Pending review'
  },
  documentation_requested: {
    chipStyles: { backgroundColor: orange[300] },
    avatarStyles: { backgroundColor: orange[900], color: '#fff' },
    icon: 'hourglass_empty',
    label: 'Requested' // 'Pending review'
  },
  draft: {
    icon: 'edit',
    label: 'Draft'
  },
  deactivated: {
    avatarStyles: { backgroundColor: red[900], color: '#fff' },
    icon: 'priority_high',
    label: 'Deactivated'
  },
  waiting: {
    chipStyles: { backgroundColor: '#ffe100ba' },
    label: 'Waiting'
  },
  active: {
    chipStyles: { backgroundColor: '#16ff00ba' },
    label: 'Active'
  },
  inactive: {
    chipStyles: { backgroundColor: '#ff0000ba' },
    label: 'Inactive'
  },
  STANDARD: {
    icon: 'star',
    label: 'Standard annonce'
  },
  PLUS: {
    chipStyles: { backgroundColor: green[300] },
    avatarStyles: { backgroundColor: green[900], color: '#fff' },
    icon: 'star',
    label: 'Plus annonce'
  },
  PREMIUM: {
    chipStyles: { backgroundColor: green[300] },
    avatarStyles: { backgroundColor: green[900], color: '#fff' },
    icon: 'star',
    label: 'Premium annonce'
  }
};
